import { Typography } from '@sanlam-glacier/app-common/components';
import styles from './summary-card.module.scss';
import { SummaryCardProps } from 'modules/case-tracking/types/case-tracking.types';
import clsx from 'clsx';
import { SummaryCardType } from 'modules/case-tracking/types/case-tracking.enums';
import { summaryCardPeriodText } from 'modules/case-tracking/utils/summary-card-period.function';

const SummaryCard = ({ ...props }: SummaryCardProps) => {
  const cardStyle = (type: SummaryCardType) => {
    switch (type) {
      case SummaryCardType.progress:
        return styles.inProgress;
      case SummaryCardType.outstanding:
        return styles.outstanding;
      case SummaryCardType.completed:
        return styles.completed;
      default:
        ('');
    }
  };

  return (
    <>
      <div
        data-testid={'case-tracking-summary-card'}
        className={clsx([styles.container, cardStyle(props.cardType)])}
      >
        <div className={styles.content}>
          <div className={styles.info}>
            <Typography
              data-testid={`case-tracking-case-count`}
              className={styles.caseCount}
              variant={Typography.VARIANT.H0}
              weight={Typography.WEIGHT.BOLD}
            >
              {props.caseCount}
            </Typography>
            <Typography
              data-testid={`case-tracking-card-description`}
              className={styles.caseDescription}
              variant={Typography.VARIANT.B3}
            >
              {props.cardType}
            </Typography>
          </div>
          <div className={styles.dates}>
            <Typography
              data-testid={`case-tracking-time-period`}
              className={styles.dateDescription}
            >
              {summaryCardPeriodText(props.cardType)}
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};

export default SummaryCard;
